import { render } from "./product-prices.vue?vue&type=template&id=7dfabd0f"
import script from "./product-prices.vue?vue&type=script&lang=js"
export * from "./product-prices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__